module.exports = __webpack_public_path__ + "img/setting-step-five.117614ca.png";